<template lang="pug">
  section.homePress 
    .homePress-background
    .homePress-container
      .homePress-titlebox
        h2.homePress-title We are in press
        p.homePress-text Featured in leading publications highlighting our expertise and success in the Turks and Caicos real estate market
      .homePress-contentbox
        a.homePress-contentItem(
          v-for='item in displayedItems',
          :key='item.id',
          :href='item.href',
          target='_blank',
          rel='noopener')
            .homePress-contentItem-image
              img(:src='item.image', :alt='item.title')
            .homePress-contentItem-title {{ item.title }}
            .homePress-contentItem-linkWrap
              .homePress-contentItem-link {{ item.source }}
              SvgComponent(name='arrow-link')
      button.homePress-showMore(v-if='!showAll && isMobile', @click='showAll = true') Show More
 
</template>

<script>
  export default {
    components: {
      SvgComponent: () => import('@/components/SvgComponent'),
      
    },
    data() {
    return {
      showAll: false,
      isMobile: false,
      pressItems: [
        {
          id: 1,
          href: 'https://blog.theagencyre.com/the-mandalay-estate-an-epic-8-acre-beachfront-compound-for-sale-in-turks-caicos/',
          image: require('@/assets/images/press/press-1.jpg'),
          title: 'The Mandalay Estate: An Epic 8-Acre Beachfront Compound For Sale in Turks & Caicos',
          source: 'The Agency Journal'
        },
        {
          id: 2,
          href: 'https://www.caribjournal.com/2023/12/12/turks-and-caicos-real-estate-association-president/',
          image: require('@/assets/images/press/press-2.jpg'),
          title: 'Ian Hurdle Appointed President of Turks and Caicos Real Estate',
          source: 'Caribbean Journal Invest'
        },
        {
          id: 3,
          href: 'https://perceptivx.com/a-story-of-perseverance-the-indomitable-spirit-of-ian-hurdle/',
          image: require('@/assets/images/press/press-3.jpg'),
          title: 'A Story of Perseverance: The Indomitable Spirit of Ian Hurdle',
          source: 'Perceptive X'
        },
        {
          id: 4,
          href: 'https://www.theagencyre.com/blog/feel-the-island-vibes-the-agency-makes-waves-with-new-jamaica-office/',
          image: require('@/assets/images/press/press-4.jpg'),
          title: 'Feel the Island Vibes: The Agency Makes Waves with New Jamaica Office',
          source: 'The Agency Journal'
        },
        {
          id: 5,
          href: 'https://www.mansionglobal.com/articles/an-off-grid-megamansion-with-a-two-level-pool-is-selling-in-turks-and-caicos-97808682?mod=',
          image: require('@/assets/images/press/press-5.jpg'),
          title: 'An Off-Grid Megamansion With a Two-Level Pool Is Selling in Turks and Caicos',
          source: 'Mansion Global'
        }
      ]
    }
  },
  computed: {
    displayedItems() {
      if (!this.isMobile || this.showAll) {
        return this.pressItems;
      }
      return this.pressItems.slice(0, 3);
    }
  },
  mounted() {
    this.checkMobile();
    window.addEventListener('resize', this.checkMobile);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobile);
  },
  methods: {
    checkMobile() {
      this.isMobile = window.innerWidth < 768; // adjust breakpoint to match your @include phone
    }
  }
  };
</script>

<style lang="scss">
.homePress {
  background: #FFFAF3;
  color: #1F1E1E;

  &-container {
    padding: 120px 0;

    @include tablet {
      padding: 60px 0;
    }

    @include phone {
      margin-left: 0;
      padding: 0 0;
    }

    .homePress-titlebox {
      display: flex;
      gap: 30px;
      justify-content: right;
      padding-bottom: 60px;
      padding-right: 120px;

      .homePress-title {
        font-size: 72px;
        font-family: "Abhaya Libre";
        font-weight: 800;
        margin-left: 30px;
      }

      .homePress-text {
        max-width: 420px;
        margin-top: 16px;
        font-size: 18px;
        line-height: 22px;
      }

      @include tablet {
        padding: 0 0 40px 0;
        gap: 20px;

        .homePress-title {
          font-size: 50px;
          margin-left: 0;
        }
        .homePress-text {
          font-size: 18px;
          margin-top: 8px;
          max-width: 50%;
        }
      }


      @include phone {
        padding: 32px 0;
        flex-direction: column;
        gap: 8px;

        .homePress-title {
          font-size: 42px;
          margin-left: 0;
        }

        .homePress-text {
          font-size: 16px;
          margin-top: 8px;
          max-width: 100%;
        }
      }


    }

    .homePress-contentbox {
      display: flex;
      gap: 32px;
      padding-bottom: 60px;
      width: 100%;
      overflow-x: scroll;

      @include tablet {
        
        gap: 20px;
        padding-bottom: 40px;
      }

      @include phone {
        flex-direction: column;
        gap: 24px;
        padding-bottom: 32px;
      }

      &::-webkit-scrollbar {
        -webkit-appearance: none;
        width: 4px;
        height: 4px;
      }

      &::-webkit-scrollbar-thumb {
        background: #888;
        border-radius: 4px;
        transition: background 0.2s ease-out;

        &:hover {
          background: $red;
          transition: background 0.2s ease-in;
        }
      }

      &::-webkit-scrollbar-track {
        background: #EDEDED;
        border-radius: 4px;

        @include phone {
          display: none;
        }
      }

      .homePress-contentItem {
        width: 393px;
        max-height: 425px;
        flex-shrink: 0;
        line-height: 22px;

        @include tablet {
          width: 210px;
          max-height: auto;
        }

        @include phone {
          width: 100%;
          max-height: auto;
        }

        &:hover {
          .homePress-contentItem-link {
            color: $red;

            &:after {
              width: 100%;
              transition: 0.2s;
            }
          }
        }

        &-title {
          margin-top: 24px;
          font-size: 18px;
          font-weight: 700;

          @include phone {
            margin-top: 16px;
            font-size: 16px;
          }
        }

        &-link {
          display: block;
          color: $red;
          font-size: 18px;
          font-weight: 700;
          cursor: pointer;
          width: max-content;
          position: relative;

          &:after {
            position: absolute;
            left: 0;
            bottom: 0;
            content: '';
            width: 0%;
            border-top: 1px solid $red;
            transition: 0.2s;
          }

          @include phone {
            font-size: 16px;
          }
        }

        &-linkWrap {
          padding-top: 8px;
          display: flex;
          gap: 10px;
          align-items: center;
        }

        &-image {
          width: 100%;
          height: 288px;
          overflow: hidden;

          @include tablet {
            height: 158px;
          }

          @include phone {
            height: auto;
          }

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            transition: transform 0.2s ease-out;
          }
        }

        &:hover {
          img {
            transform: scale(1.1);
            transition: transform 0.2s ease-in;
          }
        }
      }
    }

    .homePress-showMore {
      width: 100%;
      padding: 16px;
      background: #1F1E1E;
      color: #FFFAF3;
      border: none;
      font-size: 16px;
      font-weight: 700;
      cursor: pointer;
      margin-bottom: 32px;
      text-transform: uppercase;
      text-align: center;

      @include phone {
        display: block;
      }
    }
  }
}
</style>